/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { FaInfo, FaTag } from "react-icons/fa";
import { toast } from "react-toastify";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import { useEffect, useState } from "react";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import { TipoFormulario } from "../../../../services/constantes";
import { ApiError, Campo, Categoria } from "../../../../services/tipos";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { obterIdTenent, usuarioTemPermissao } from "../../../../services/seguranca";
import { useFiliais } from "../../../../hooks/useFiliais";
import { CHAVE_CATEGORIA_CAUCAO, invalidarNomeCaucao } from "../../../../hooks/useNomeCaucao";

function CategoriaListagem() {
    const { empresaTemFiliais, filiaisOptions, filialSelecionada, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [categorias, setCategorias] = useState<Categoria[]>([]);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [categoriaSelecionado, setCategoriaSelecionado] = useState<Categoria>({} as Categoria);

    const colunas = [
        { field: 'nome', headerName: 'Nome', flex: 1 },
        { 
            field: 'cor', 
            headerName: 'Cor', 
            flex: 1,
            renderCell: (params: any) => {
                const corHexadecimal = params.row.cor;
    
                const labelStyle: React.CSSProperties = {
                    backgroundColor: corHexadecimal,
                    color: "#ffffff",
                    padding: "5px 10px",
                    borderRadius: "5px",
                    fontWeight: "bold",
                    textAlign: "center" as "center",
                };
    
                return <span style={labelStyle}>{corHexadecimal.toUpperCase()}</span>;
            }
        },
        { field: 'descricao', headerName: 'Descrição', flex: 1 },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade', flex: 1,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const filial = filiaisOptions.find((f: any) => f.valor === params.value);
                return filial?.label || '';
            }
        }] : []),
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6 });

    // A categoria de caução é de sistema, mas o nome é do locador: ele pode chamá-la de ADESÃO,
    // GARANTIA etc. A descrição acompanha o nome e o servidor a monta sozinho.
    const ehCaucao = categoriaSelecionado?.chave === CHAVE_CATEGORIA_CAUCAO;

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Nome', nome: 'nome', required: true, tipo: 'text', largura: 6, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Cor', nome: 'cor', required: false, tipo: 'color', largura: 6, coluna: 21, linha: 1, visible: true, tudoMaiusculo: true },
        { label: 'Descrição', nome: 'descricao', required: !ehCaucao, tipo: 'memo', largura: 12, coluna: 1, linha: 2, visible: true, tudoMaiusculo: true, apenasLeitura: ehCaucao },
        {
            label: '', nome: '_avisoCaucao', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 3, visible: ehCaucao && modo !== TipoFormulario.tpVisualizacao,
            alertType: 'info', alertIcon: FaInfo, alertTitle: 'Categoria usada na caução das locações',
            alertMessage: 'Você pode trocar o nome (ex.: ADESÃO). O novo nome passa a aparecer nos lançamentos e nas cobranças do Asaas das próximas locações, e nos campos da tela de locação. Os lançamentos já criados continuam com o nome antigo. A descrição acompanha o nome automaticamente.',
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 4, visible: false, tudoMaiusculo: true },
    ];

    const temPermissao = usuarioTemPermissao(token, 'categoria_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        const mensagem = error.response?.data.Mensagem != undefined ? error.response?.data.Mensagem : 'Escolha uma cor diferente de #000000';
        toast.error('Não foi possível continuar a operação Categoria: ' + mensagem);
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = async () => {
        if (usuarioTemPermissao(token, 'categoria_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setCategoriaSelecionado({ ...(filialSelecionada ? { idFilial: filialSelecionada } : {}) } as Categoria);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar uma nova categoria');
        }
    }

    const handleEditar = async (categoria: any) => {
        if (usuarioTemPermissao(token, 'categoria_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setCategoriaSelecionado(categoria);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar uma categoria');
        }
    }

    const handleExclusao = async (categoria: Categoria) => {
        if (usuarioTemPermissao(token, 'categoria_excluir')) {
            setCarregando(true);
            await api.delete(`/categoria/${categoria.id}`)
                .then(response => {
                    setTimeout(() => {
                        toast.success('Categoria foi excluída com sucesso');
                        setRealizarConsulta(true)
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }
    }

    const handleVisualizacao = async (categoria: any) => {
        if (usuarioTemPermissao(token, 'categoria_visualizar')) {
            setCategoriaSelecionado(categoria);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao)
        }
    }

    useEffect(() => {
        const fetchCategoriaPorEmpresa = async () => {
            if ((temPermissao) && (realizarConsulta)) {
                setCarregando(true);
                await api.get(`/CategoriaPorEmpresa/${obterIdTenent(token)}`)
                    .then(response => {
                        setTimeout(() => {
                            setCategorias(response.data);
                            setRealizarConsulta(false);
                            setCarregando(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error);
                    });
            }
        }

        fetchCategoriaPorEmpresa();
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (response: any) => {
        if (ehCaucao) invalidarNomeCaucao();
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Categoria salva com sucesso');
        setFezAlgumaAcao(true);
    }

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('categoria')}
                    colunas={colunas}
                    linhas={categorias}
                    nomeEntidade="Categoria"
                    nomePropriedade="nome"
                    carregando={carregando}
                    IconeEntidade={FaTag}
                    exibirAcoesDeCrud={true}
                    handleEditar={handleEditar}
                    handleCriar={handleCadastrar}
                    handleExclusao={handleExclusao}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setCategoriaSelecionado}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('Categoria', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Categoria', () => setRealizarConsulta(true))!] : []),
                    ]}
                />

                <ModalForm
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    ajudinha={
                        {
                            texto: "Aqui você poderá cadastrar categorias que serão utilizados em movimentações, como a de manutenções. Esses cadastros facilitam a seleção nas telas de movimentação, garantindo uma escolha rápida e a padronização das operações.",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={categoriaSelecionado}
                    apiConfig={
                        {
                            endpoint: "categoria",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />
            </LocaSmartLayout>
        </>
    );
}

export default CategoriaListagem;